import { useState } from "react";
import { Calendar as CalendarIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { format } from "date-fns";

export default function DateRangePicker({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const range = value || { from: undefined, to: undefined };

  const display = () => {
    if (range?.from && range?.to) {
      return `${format(range.from, "MMM d, yyyy")} → ${format(range.to, "MMM d, yyyy")}`;
    }
    if (range?.from) {
      return `${format(range.from, "MMM d, yyyy")} → ...`;
    }
    return "All Time";
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          className="bg-[var(--bg-input)] border-[var(--border-subtle)] text-[var(--text-primary)] hover:bg-[var(--bg-hover)] hover:text-[var(--text-primary)] font-normal"
          data-testid="date-range-picker"
        >
          <CalendarIcon className="w-4 h-4 mr-2 text-[var(--text-muted)]" strokeWidth={1.5} />
          <span className="text-xs font-mono-data">{display()}</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className="w-auto p-0 bg-[var(--bg-input)] border-[var(--border-subtle)]"
        align="start"
        data-testid="date-range-popover"
      >
        <Calendar
          mode="range"
          selected={range}
          onSelect={(r) => onChange(r)}
          numberOfMonths={2}
          initialFocus
          className="bg-[var(--bg-input)] text-[var(--text-primary)]"
        />
        <div className="flex justify-between p-3 border-t border-[var(--border-subtle)]">
          <Button
            variant="ghost"
            size="sm"
            className="text-[var(--text-muted)] hover:text-[var(--text-primary)] hover:bg-[var(--bg-hover)]"
            onClick={() => {
              onChange({ from: undefined, to: undefined });
            }}
            data-testid="date-range-clear"
          >
            Clear
          </Button>
          <Button
            size="sm"
            className="bg-[var(--bg-inverse)] text-[var(--text-inverse)] hover:bg-[var(--bg-inverse-hover)]"
            onClick={() => setOpen(false)}
            data-testid="date-range-apply"
          >
            Apply
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
